import { css } from 'styled-components';

export const MidnightGlassSkin = css`
  background: linear-gradient(145deg, #0b1220, #020409);
  border: 4px solid rgba(255, 255, 255, 0.15);
  box-shadow:
    inset 0 0 12px rgba(255, 255, 255, 0.05),
    0 10px 30px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
`;

export const MidnightGlassWrapperSkin = css`
  background: radial-gradient(circle at top, #1a2538 0%, #020409 70%);
`;

export const MidnightGlassLetterSkin = css<{ $isActive: boolean }>`
  color: ${({ $isActive }) => ($isActive ? '#ffffff' : '#7f8fa3')};
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.15)};
  text-shadow: ${({ $isActive }) => ($isActive ? '0 0 6px rgba(255,255,255,0.4)' : 'none')};
`;
